package io.horion.cv.models

fun defaultTitleFor(
    type: PersonalizedSectionType
): String {
    return when (type) {
        PersonalizedSectionType.DESCRIPTION -> "Description"
        PersonalizedSectionType.ENTRIES -> "Entrée"
        PersonalizedSectionType.COMPETENCES -> "Compétence"
        PersonalizedSectionType.LIST -> "Liste"
    }
}